"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOX_BASE_WIDTH = exports.BOX_BASE_HEIGHT = exports.CIRCLE_BASE_SIZE = void 0;
var CIRCLE_BASE_SIZE = 32;
exports.CIRCLE_BASE_SIZE = CIRCLE_BASE_SIZE;
var BOX_BASE_HEIGHT = 15;
exports.BOX_BASE_HEIGHT = BOX_BASE_HEIGHT;
var BOX_BASE_WIDTH = 40;
exports.BOX_BASE_WIDTH = BOX_BASE_WIDTH;